import { NgForOf, NgIf } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatOption, MatSelect } from '@angular/material/select';
import {
  ActionData,
  ActionsOperators,
  Entities,
  IAwesomeDocsWorkflowConfig
} from '../../data-rules-model';
import { DataRulesService } from '../../data-rules.service';
import { ICustomPositioningConfig } from '../../lib/custom-component-overlay.directive';
import { IEntityItem } from '../../lib/paired-autocomplete/paired-autocomplete.component';
import { MetaDataService, MetaSource } from '../../meta-data.service';
import { IrreversibleActionWarningBlockComponent } from '../action-warning-block/irreversible-action-warning-block.component';

@Component({
  selector: 'app-action-awesome-docs',
  imports: [
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    NgForOf,
    IrreversibleActionWarningBlockComponent,
    NgIf
  ],
  templateUrl: './awesome-docs.component.html',
  styles: [`
    h3 { padding-top: 0; margin-bottom: 8px; line-height: 1; }
    mat-select { margin-bottom: 8px; }
  `]
})
export class AwesomeDocsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() actionData: ActionData;
  @Input() actionForm: FormGroup;
  @Input() primaryEntity: Entities;

  destinationTypeControl = new FormControl(null);
  actionTypeControl = new FormControl(null);
  configControl: FormControl;
  warningMessage = '';
  docusignEnabled: boolean = false;
  entityMap: any;

  @ViewChild('fieldName')

  dataSourceType = MetaSource.ACTION;
  loading = true;

  overlayPositioningConfig: ICustomPositioningConfig = {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 8,
    offsetX: -20
  };

  configs: IAwesomeDocsWorkflowConfig[] = [];
  entitiesOptions: IEntityItem[];

  constructor(protected dataRulesService: DataRulesService,
              private metaDataService: MetaDataService) {
  }

  ngOnInit() {
    this.createControls();
    this.getConfigs();
    this.entityMap = this.metaDataService.getEntitiesLabelsMap();
    this.warningMessage = `This rule is irreversible and will create new ${this.entityMap[this.primaryEntity]} file attachments.`
  }

  ngAfterViewInit() {
  }

  getConfigs() {
    this.dataRulesService.getAwesomeDocsConfigs(this.primaryEntity).subscribe((configs) => {
      this.configControl.enable();
      this.loading = false;
      this.configs = configs.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  public configPlaceholder(): string {
    if (this.loading) {
      return 'Loading AwesomeDocs...';
    }
    if (this.configs && this.configs.length > 0) {
      return 'Choose AwesomeDoc...';
    }
    return 'You have no AwesomeDocs.';
  }

  private createControls(): void {
    this.actionTypeControl = new FormControl(this.actionData.type);
    this.configControl = new FormControl(this.actionData.value);
    this.actionForm.addControl('type', this.actionTypeControl);
    this.actionForm.addControl('value', this.configControl);
    this.actionTypeControl.setValue(ActionsOperators.AWESOMEDOCS);
    this.configControl.setValue(this.actionData.value);
  }

  removeAllControls() {
    this.actionForm.removeControl('type');
    this.actionForm.removeControl('value');
  }

  ngOnDestroy(): void {
    this.removeAllControls();
  }

  updateDocusignEnabled(event: MatOptionSelectionChange): void {
    if (event.isUserInput) {
      let id = event.source.value;
      if (id) {
        let config: IAwesomeDocsWorkflowConfig = this.configs.find(c => c.id == id);
        this.docusignEnabled = config.actionConfigs.filter(ac => ac.type === "signature" && ac.properties?.request?.enabled).length > 0;
      } else {
        this.docusignEnabled = false;
      }
    }
  }
}
